import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});


export default function CustomMappingTable(props) {
  const classes = useStyles();
  const rows = props?.data
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Program Outcomes (POs) / Program Educational Objectives (PEOs)</TableCell>
            {props?.detailHeader.map(data=>(<TableCell align='right'>{data}</TableCell>))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row,index) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                PO{index+1+" "+row.statement}
              </TableCell>
              <TableCell align="right">1</TableCell>
              <TableCell align="right">2</TableCell>
            </TableRow>
          ))}
          {rows.map((row,index) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                PSO{index+1+" "+row.po_reference}
              </TableCell>
              <TableCell align="right">1</TableCell>
              <TableCell align="right">2</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
